export const TIDS = {
  // Home
  homeHeading: "home-heading",
  homeBroadwayCard: "home-trip-broadway",
  homeOvernightCard: "home-trip-overnight",
  homeAdminLink: "home-admin-link",

  // Trip
  tripHeading: "trip-heading",
  tripRegisterBtn: "trip-register-btn",
  tripFlyer: "trip-flyer",
  tripClosedNotice: "trip-closed-notice",

  // Register flow
  camperSelect: "camper-select",
  camperItem: "camper-item",
  parentPrintName: "field-parent-print-name",
  parentEmail: "field-parent-email",
  camperGrade: "field-camper-grade",
  submitReview: "submit-review",
  reviewBack: "review-back",
  reviewProceed: "review-proceed",
  signTypeTab: "sign-tab-type",
  signDrawTab: "sign-tab-draw",
  signTypedInput: "sign-typed-input",
  signCanvas: "sign-canvas",
  signClear: "sign-clear",
  signSubmit: "sign-submit",
  payCard: "pay-card",
  payOffice: "pay-office",
  paySubmit: "pay-submit",
  doneMessage: "done-message",

  // Admin
  adminEmail: "admin-email",
  adminPassword: "admin-password",
  adminSubmit: "admin-submit",
  adminNav: "admin-nav",
  adminRegRow: "admin-reg-row",
  adminPaidToggle: "admin-paid-toggle",
  adminStatusToggle: "admin-status-toggle",
  adminDownloadPdf: "admin-download-pdf",
  adminSaveTrip: "admin-save-trip",
  adminFlyerUpload: "admin-flyer-upload",
  adminCloseTrip: "admin-close-trip",
  adminOpenTrip: "admin-open-trip",
  adminSaveHome: "admin-save-home",
  adminSaveSeason: "admin-save-season",
  adminSyncCampminder: "admin-sync-campminder",
  adminAddManualCamper: "admin-add-manual-camper",
};
